// 基于 axios 封装网络请求

import theAxios from 'axios'
import router from '@/router'
import { Notify } from 'vant'
import { getToken, delToken } from '@/utils/token.js'

const axios = theAxios.create({
  // baseURL: 'http://www.yue606.com:8082',
  baseURL: '/',
  // baseURL: `${process.env.VUE_APP_INTERFACE_URL}:${process.env.VUE_APP_INTERFACE_PORT}`,
  timeout: 20000, // 20s超时时间（请求20s无响应直接判定超时）
  headers: {
    'Content-Type': 'application/json',
    'X-Custom-Header': 'foobar'
  }
})

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // 目标：统一携带token
    // 判断本地有token再携带，判断具体api/index.js里如果没有携带Authorization，我再添加上去
    // 未定义叫undefine，null具体的值你得赋予才叫空
    // ?. 可选链操作符，如果前面对象没有length，原地返回undefined
    // 如果getToken()在原地有值token字符串，才能调用length获取长度，否则报错

    if (getToken()?.length > 0 && config.headers.Authorization === undefined) {
      config.headers.Authorization = `Bearer ${getToken()}`
    }
    // console.log(config)
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
// 本质：一个函数
axios.interceptors.response.use(
  function (response) {
    // http响应状态码为2xx,3xx就进入这里
    // 对响应数据做点什么

    // 用于解决本工程特有问题，即http响应状态码为200，但是内层自定义状态码为401，此时代表身份过期，需要跳转到登录
    if (response.data.code === 401) {
      Notify({ type: 'warning', message: '身份验证已过期，请重新登录！' })
      delToken()
      router.replace(`/login?path=${router.currentRoute.fullPath}`)
    } else {
      // 这次是真的没问题了，可以返回response了
      return response
    }
  },
  function (error) {
    // http响应状态码为4xx,5xx报错进入这里
    // 对响应错误做点什么
    console.dir(error)
    // 只有401才代表身份过期，才需要跳转到登录
    if (error.response.status === 401) {
      Notify({ type: 'warning', message: '身份验证已过期，请重新登录！' })
      // 不能使用this.$router（因为这里的this不是vue组件对象，无法调用$router
      // 解决：this.$router为了拿到router路由对象，所以直接在上面引用@/router下的router路由对象
      delToken()

      router.replace(`/login?path=${router.currentRoute.fullPath}`)
    }
    return Promise.reject(error)
  }
)

export default ({
  url,
  method = 'GET',
  params = {},
  data = {},
  headers = {}
}) => {
  return axios({
    url,
    method,
    params,
    data,
    headers
  })
}

// export default axios
// 但是上面有局限性，
// 导出的axios方法在使用时
// 我在逻辑页面调用时，传入这五个配置名字
/*
  axios({
    url:'请求地址',
    method: '请求方式',
    params: {
      ?传参
    },
    data: {
      请求体传参
    }
    headers: {
      请求头
    }
  })
*/
// 问题来了，万一将来我要更新request.js里封装网络请求的工具
// 把axios换成jquery的$.ajax
// import $ from 'jquery'
// export default $.ajax
/*
  $.ajax({
    url:'请求地址',
    type:'请求方式',
    data:{},  //没有params
    headers:{} //请求头
    success: (res) => {
      resolve(res)
    },
    error: err => {
      reject(err)
    }
  })

*/
